import React from 'react';
import cx from 'classnames';
import { Typography } from '../../../atoms/typography/Typography';

const ConfirmationModal = ({
  isOpen,
  title,
  message,
  styledMessage,
  confirmText,
  confirmColor = 'red',
  cancelText,
  cancelColor = 'transparent',
  onConfirm,
  onCancel,
  t,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-[99999] bg-black bg-opacity-50 px-8">
      <div className="bg-white p-8 rounded-lg shadow-md">
        {title && (
          <Typography fontVariant="h6" className="mb-4">
            {title}
          </Typography>
        )}
        {message && (
          <Typography fontVariant="md" className="mb-4">
            {message}
          </Typography>
        )}
        {styledMessage && (
          <div
            className="mb-4 text-clamp-md"
            dangerouslySetInnerHTML={{ __html: styledMessage }}
          />
        )}
        <div className="flex justify-between">
          <button
            type="button"
            className={cx(
              'border text-clamp-sm text-white font-medium px-6 py-2 rounded-[48px] uppercase',
              {
                'bg-red-500 border-red-500': confirmColor === 'red',
                'bg-teal-500 border-teal-500': confirmColor === 'green',
                'bg-transparent border-customGray-300 text-customGray-700':
                  confirmColor === 'transparent',
              }
            )}
            onClick={onConfirm}
          >
            {confirmText ?? t('spQf.yes')}
          </button>
          <button
            type="button"
            className={cx(
              'border text-clamp-sm font-medium text-white px-6 py-2 rounded-[48px] uppercase',
              {
                'bg-transparent border-customGray-300 !text-customGray-700':
                  cancelColor === 'transparent',
                'bg-red-500 border-red-500': cancelColor === 'red',
              }
            )}
            onClick={onCancel}
          >
            {cancelText ?? t('spQf.no')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
